import 'simplebar'

export default {}
